/**
 * Registers a 'click' event handler on the element with the specified id,
 * if it exists in the DOM. Accepts a string ID or an element reference.
 *
 * The event object is augmented with a `.stop()` method (combining
 * `preventDefault` + `stopPropagation`) for backward compatibility with
 * callers that were written against MooTools' event API.
 */
export function clickSafe(id: string | HTMLElement | null, eventHandler: (e: Event) => void): void {
   const element = typeof id === 'string' ? document.getElementById(id) : id;
   if (element) {
      element.addEventListener('click', (e: Event) => {
         (e as any).stop ??= () => {
            e.preventDefault();
            e.stopPropagation();
         };
         eventHandler.call(element, e);
      });
   }
}
